'use client';
import { useEffect, useState } from 'react';

import { UiLandingFooterEsthederm } from '@/fo/ui/landing/footer/esthederm';
import { UiLandingHeaderEsthederm } from '@/fo/ui/landing/header/esthederm';
import { UiLandingNavigationEsthederm } from '@/fo/ui/landing/navigation/esthederm';
import { Product } from '@/fo/ui/landing/product-card/esthederm';

import { Bundle } from '../components/Bundle/Bundle';
import { BuyNow } from '../components/BuyNow/BuyNow';
import { CareSection } from '../components/CareSection/CareSection';
import { HeroBanner } from '../components/HeroBanner/HeroBanner';
import { HeroVideo } from '../components/HeroVideo/HeroVideo';
import { ProductSection } from '../components/ProductSection/ProductSection';
import { Technology } from '../components/Technology/Technology';

import { styles } from './FeatureLandingPageIntensiveNad.styles';

export interface Navigation {
  label: React.ReactNode;
  anchor: string;
}

export interface FeatureLandingPageIntensiveNadProps {
  navigation: Navigation[];
  bgFooter: {
    md: string;
    sm: string;
  };
  footnotes?: Array<{
    id: string;
    content: React.ReactNode;
  }>;
  trioProducts?: Product[];
  careProducts?: Product[];
  bundleProduct?: Product;
}

export function FeatureLandingPageIntensiveNad({
  navigation,
  bgFooter,
  footnotes,
  trioProducts,
  careProducts,
  bundleProduct
}: FeatureLandingPageIntensiveNadProps) {
  const slots = styles();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isNearFooter, setIsNearFooter] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      setIsScrolled(scrollY > 100);
      setIsNearFooter(scrollY + windowHeight > documentHeight - 200);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={slots.base()}>
      <UiLandingHeaderEsthederm progressColor="#a59fe3" />
      <main>
        <div className="relative">
          <HeroBanner />
          <UiLandingNavigationEsthederm
            className={slots.navigation({ isScrolled, isNearFooter })}
            items={navigation}
          />
        </div>
        <Technology />
        {trioProducts && <ProductSection products={trioProducts} />}
        <HeroVideo />
        {careProducts && (
          <div className="overflow-hidden bg-[linear-gradient(180deg,#CCC6E2_0%,#FFFFFF_100%)]">
            <CareSection products={careProducts} />
          </div>
        )}
        {bundleProduct && <Bundle product={bundleProduct} />}
        <BuyNow isNearFooter={isNearFooter} />
      </main>
      <UiLandingFooterEsthederm
        bgFooter={bgFooter}
        footnotes={footnotes}
      />
    </div>
  );
}
